import myAssortmentNo from '../resources/no/my-assortment.json';
import myAssortmentSe from '../resources/se/my-assortment.json';
import { MyAssortmentLanguageResources } from '../types/MyAssortmentResources';

export const myAssortmentI18nResources: MyAssortmentLanguageResources = {
  no: { myAssortment: myAssortmentNo },
  se: { myAssortment: myAssortmentSe },
};